export default __webpack_public_path__ + "6a108bd500f0c7dee2d54f84444b49ac.png";